import React, { useContext } from "react";
import { CatTagContext } from "../../contexts/CatTagContext";
import AddCategory from "./AddCategory";
import CatItem from "./CatItem";

const Categories = () => {
  const { categories } = useContext(CatTagContext);
  return (
    <div className="flex-grow parent">
      <div className="flex font-medium text-sm text-gray-400 px-4 my-4 uppercase">
        CATEGORIES
      </div>
      <AddCategory />
      <div style={{ maxHeight: "44vh" }} className="w-full child">
        {categories.map((e) => {
          return (
            <CatItem
              key={e.cid}
              category={e.category}
              cid={e.cid}
              count={e.count}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Categories;
